import {IController} from "angular";
import {LqbFundedLogServiceName, ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {LqbFundedLogService} from "../services/LqbFundedLogService";
import {ImportReportLogFilter} from "../../opportunities_filter/model/OpportunityFilterUi";
import {LqbFundedReportLog} from "../model/LqbFundedReportLog";
import './funded-logging.scss';
import {Pageable} from "../../utils/models/Page";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {ImportSource} from "../../manual_import/model/ImportSource";
import {TriggeredBy} from "../../manual_import/model/TriggeredBy";


export class LqbLoggingController implements IController {

    public static instance = [LqbFundedLogServiceName, ToastNotificationServiceName, LqbLoggingController];

    private pageable: Pageable;

    private filter: ImportReportLogFilter;

    private showLoading: boolean;

    private fundedLogs: LqbFundedReportLog[];

    constructor(private lqbFundedLogService: LqbFundedLogService,
                private toastNotficationService: ToastNotificationService) {
        this.pageable = {
            page: 1, pageSize: 10, totalElements: 0, fetchPage: this.onPaging
        };
    }

    private onPaging = () => {
        this.onFilterValueChange(this.filter);
    };

    private onFilterValueChange = (filter: ImportReportLogFilter) => {
        this.showLoading = true;
        this.filter = filter;
        this.filter.fetchPersistedCustomers = true;
        this.filter.importSource = [ImportSource.LQB, ImportSource.CANCELED];
        this.filter.triggeredBy = TriggeredBy.AUTOMATIC;
        let pageNuber = this.pageable.page - 1;
        let pageSize = this.pageable.pageSize;
        this.lqbFundedLogService.getLqbFundedLogs(pageNuber, pageSize, filter)
            .then(resp => {
                this.showLoading = false;
                if (resp.status == 200) {
                    this.handleNewLogsPage(resp);
                } else {
                    this.toastNotficationService.generateErrorMessage("Failed to fetch funded logs.");
                }
            })
    };


    private handleNewLogsPage(resp) {
        let logsPage = resp.data;
        this.fundedLogs = logsPage.content;
        this.pageable.totalElements = logsPage.totalElements;
        this.pageable.page = logsPage.number + 1;
        this.pageable.pageSize = logsPage.size;
    }
}